import { useContext } from 'react';

import { AlertContext, AlertTextContext, AlertTypeContext, IsAlertOpenContext } from '../context';

export const useIsAlertOpen = () => useContext(IsAlertOpenContext)!;
export const useAlertText = () => useContext(AlertTextContext)!;
export const useAlertType = () => useContext(AlertTypeContext)!;
export const useAlert = () => useContext(AlertContext)!;